import {
  BASE_URL,
  AOE_LOINC_DATA,
  AOE_LOINC,
  ERROR_MSG,
  API_GATEWAY_KEY,
} from "./Constants";
import Cookies from "js-cookie";

export const fetchAoeLoincData = async (
  pageNo,
  recordsPerPage,
  urlWithParams
) => {
  let response = await fetch(
    `${BASE_URL}${AOE_LOINC_DATA}/${pageNo}/${recordsPerPage}?${urlWithParams}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const addNewAoeLoinc = async (form) => {
  let response = await fetch(`${BASE_URL}${AOE_LOINC}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  let data = await response.json();
  return data;
};

export const fetchAoeLoincById = async (aoeLoincId) => {
  let response = await fetch(`${BASE_URL}${AOE_LOINC}/${aoeLoincId}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const updateAoeLoincRecord = async (form) => {
  let response = await fetch(`${BASE_URL}${AOE_LOINC}`, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  let data = await response.json();
  return data;
};

export const removeAoeLoincRecord = async (aoeLoincId) => {
  let response = await fetch(`${BASE_URL}${AOE_LOINC}/${aoeLoincId}`, {
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  if (!response.ok) {
    return ERROR_MSG;
  }
};
